import React from 'react';
import Text from 'components/Text';
import QuotesTable from 'components/Table/Quotes';
import { RootState } from 'store/ducks';
import { useSelector } from 'react-redux';

const Quotes: React.FC = () => {
  const user = useSelector((state: RootState) => state.user);
  return (
    <>
      <Text size={24} className="color-primary font-bold">
        Cotações
      </Text>

      <QuotesTable
        trackingKey="Grid Cotações"
        showFilter
        pageSize={10}
        showExportButton={user?.userType === 'employee'}
      />
    </>
  );
};

export default Quotes;
